module.exports = __webpack_public_path__ + "img/椰子.e288bb8f.png";